// extracted by mini-css-extract-plugin
export default {"anmCheckboxDeclaracaoContainer":"anmCheckboxDeclaracao_anmCheckboxDeclaracaoContainer__o7Psv"};